import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';
import {inject, Injectable} from '@angular/core';
import {BaseUserService} from '../api/base-user.service';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {License} from '../api/logged-in-user';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {APIResponse} from '@app/layout/admin/services/api/api.interface';
import {HttpUtilityService} from '@shared/services/api/http-utility-service';
import {StringUtils} from '@shared/util/general/string-utils';

export const licenseResolver: ResolveFn<License> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<License> => {
  return inject(LicenseService).getLicenseForCustomer(StringUtils.stringToNumber(route.paramMap.get('id')));
};


@Injectable({
  providedIn: 'root'
})
export class LicenseService extends BaseUserService {

  private headers: HttpHeaders = this.getHeaders();
  private readonly logger: AceLogger;
  private readonly LICENSE_OPERATION = 'license';
  
  constructor(private http: HttpClient,
              private httpUtilityService: HttpUtilityService,
              logService: AceLoggerService) {
    super();
    this.logger = logService.create(LicenseService.name);
  }

  getLicenseForCustomer(customerId: number): Observable<License> {
    const options = {headers: this.headers};
    return this.http.get(this.getGateway() + '/licenses/customers/' + customerId, options)
      .pipe(map((response: APIResponse<License>) => this.httpUtilityService.extractResponseData(response, this.LICENSE_OPERATION)));
  }

  updateLicense(customerId: number, license: License) {
    const options = {headers: this.headers};
    return this.http.put(this.getGateway() + '/licenses/customers/' + customerId, license, options);
  }

}
